import React from 'react'
import LiveCollectionCharts from "./LiveCollectionCharts"
import LineChart from"./LineChart"
import BarChartForSaleForTrade from "./BarChartForSaleForTrade"
const PersonalCollection = () => {
  const spendPerDay = [
    { GraphId: 2, UserId: 1, DateSaved: '2024-01-06', TotalValue: 105, TotalCost: 103 },
    { GraphId: 1, UserId: 1, DateSaved: '2024-01-05', TotalValue: 100, TotalCost: 100 },
    { GraphId: 3, UserId: 1, DateSaved: '2024-01-07', TotalValue: 110, TotalCost: 106 },
    { GraphId: 4, UserId: 1, DateSaved: '2024-01-08', TotalValue: 115, TotalCost: 109 },
    { GraphId: 5, UserId: 1, DateSaved: '2024-01-09', TotalValue: 120, TotalCost: 112 },
    { GraphId: 6, UserId: 1, DateSaved: '2024-01-10', TotalValue: 125, TotalCost: 115 },
    { GraphId: 7, UserId: 1, DateSaved: '2024-01-11', TotalValue: 130, TotalCost: 118 },
    { GraphId: 8, UserId: 1, DateSaved: '2024-01-12', TotalValue: 135, TotalCost: 121 },
    { GraphId: 9, UserId: 1, DateSaved: '2024-01-13', TotalValue: 140, TotalCost: 124 },
    { GraphId: 10, UserId: 1, DateSaved: '2024-01-14', TotalValue: 145, TotalCost: 127 },
    { GraphId: 11, UserId: 1, DateSaved: '2024-01-15', TotalValue: 150, TotalCost: 130 },
    { GraphId: 12, UserId: 1, DateSaved: '2024-01-16', TotalValue: 155, TotalCost: 133 },
    { GraphId: 13, UserId: 1, DateSaved: '2024-01-17', TotalValue: 160, TotalCost: 136 },
    { GraphId: 14, UserId: 1, DateSaved: '2024-01-18', TotalValue: 165, TotalCost: 139 },
    { GraphId: 15, UserId: 1, DateSaved: '2024-01-19', TotalValue: 170, TotalCost: 142 },
    { GraphId: 16, UserId: 1, DateSaved: '2024-01-20', TotalValue: 175, TotalCost: 145 },
    { GraphId: 17, UserId: 1, DateSaved: '2024-01-21', TotalValue: 180, TotalCost: 148 },
    { GraphId: 18, UserId: 1, DateSaved: '2024-01-22', TotalValue: 185, TotalCost: 151 },
    { GraphId: 19, UserId: 1, DateSaved: '2024-01-23', TotalValue: 190, TotalCost: 154 },
    { GraphId: 20, UserId: 1, DateSaved: '2024-01-24', TotalValue: 195, TotalCost: 157 },
    { GraphId: 21, UserId: 1, DateSaved: '2024-01-25', TotalValue: 200, TotalCost: 160 },
    { GraphId: 22, UserId: 1, DateSaved: '2024-01-26', TotalValue: 205, TotalCost: 163 },
    { GraphId: 23, UserId: 1, DateSaved: '2024-01-27', TotalValue: 210, TotalCost: 166 },
    { GraphId: 24, UserId: 1, DateSaved: '2024-01-28', TotalValue: 215, TotalCost: 169 },
    { GraphId: 25, UserId: 1, DateSaved: '2024-01-29', TotalValue: 220, TotalCost: 172 },
    { GraphId: 26, UserId: 1, DateSaved: '2024-01-30', TotalValue: 225, TotalCost: 175 },
    { GraphId: 27, UserId: 1, DateSaved: '2024-01-31', TotalValue: 230, TotalCost: 178 },
    { GraphId: 28, UserId: 1, DateSaved: '2024-02-01', TotalValue: 235, TotalCost: 181 },
    { GraphId: 29, UserId: 1, DateSaved: '2024-02-02', TotalValue: 240, TotalCost: 184 },
    { GraphId: 30, UserId: 1, DateSaved: '2024-02-03', TotalValue: 245, TotalCost: 187 },
  ];
  
  // Define the SpendPerDay data with both price and paidPrice and unique ids
  const spendPerWeek = [
    {
      GraphId: 1,
      UserId: 1,
      DateSaved: '2023-10-30',
      TotalValue: 100,
      TotalCost: getRandomPrice(100),
      TotalForSale: getRandomPrice(100) + 25,
      TotalForTrade: getRandomPrice(100) + 25,
    },
    {
      GraphId: 2,
      UserId: 1,
      DateSaved: '2023-11-06',
      TotalValue: 120,
      TotalCost: getRandomPrice(120),
      TotalForSale: getRandomPrice(120) + 25,
      TotalForTrade: getRandomPrice(120) + 25,
    },
    {
      GraphId: 3,
      UserId: 1,
      DateSaved: '2023-11-13',
      TotalValue: 130,
      TotalCost: getRandomPrice(130),
      TotalForSale: getRandomPrice(130) + 25,
      TotalForTrade: getRandomPrice(130) + 25,
    },
    {
      GraphId: 4,
      UserId: 1,
      DateSaved: '2023-11-20',
      TotalValue: 110,
      TotalCost: getRandomPrice(110),
      TotalForSale: getRandomPrice(110) + 25,
      TotalForTrade: getRandomPrice(110) + 25,
    },
    {
      GraphId: 5,
      UserId: 1,
      DateSaved: '2023-11-27',
      TotalValue: 105,
      TotalCost: getRandomPrice(105),
      TotalForSale: getRandomPrice(105) + 25,
      TotalForTrade: getRandomPrice(105) + 25,
    },
    {
      GraphId: 6,
      UserId: 1,
      DateSaved: '2023-12-04',
      TotalValue: 95,
      TotalCost: getRandomPrice(95),
      TotalForSale: getRandomPrice(95) + 25,
      TotalForTrade: getRandomPrice(95) + 25,
    },
    {
      GraphId: 7,
      UserId: 1,
      DateSaved: '2023-12-11',
      TotalValue: 115,
      TotalCost: getRandomPrice(115),
      TotalForSale: getRandomPrice(115) + 25,
      TotalForTrade: getRandomPrice(115) + 25,
    },
    {
      GraphId: 8,
      UserId: 1,
      DateSaved: '2023-12-18',
      TotalValue: 120,
      TotalCost: getRandomPrice(120),
      TotalForSale: getRandomPrice(120) + 25,
      TotalForTrade: getRandomPrice(120) + 25,
    },
    {
      GraphId: 9,
      UserId: 1,
      DateSaved: '2023-12-25',
      TotalValue: 140,
      TotalCost: getRandomPrice(140),
      TotalForSale: getRandomPrice(140) + 25,
      TotalForTrade: getRandomPrice(140) + 25,
    },
    {
      GraphId: 10,
      UserId: 1,
      DateSaved: '2024-01-01',
      TotalValue: 150,
      TotalCost: getRandomPrice(150),
      TotalForSale: getRandomPrice(150) + 25,
      TotalForTrade: getRandomPrice(150) + 25,
    },
    {
      GraphId: 11,
      UserId: 1,
      DateSaved: '2024-01-08',
      TotalValue: 160,
      TotalCost: getRandomPrice(160),
      TotalForSale: getRandomPrice(160) + 25,
      TotalForTrade: getRandomPrice(160) + 25,
    },
    {
      GraphId: 12,
      UserId: 1,
      DateSaved: '2024-01-15',
      TotalValue: 130,
      TotalCost: getRandomPrice(130),
      TotalForSale: getRandomPrice(130) + 25,
      TotalForTrade: getRandomPrice(130) + 25,
    },
    {
      GraphId: 13,
      UserId: 1,
      DateSaved: '2024-01-22',
      TotalValue: 125,
      TotalCost: getRandomPrice(125),
      TotalForSale: getRandomPrice(125) + 25,
      TotalForTrade: getRandomPrice(125) + 25,
    },
    {
      GraphId: 14,
      UserId: 1,
      DateSaved: '2024-01-29',
      TotalValue: 140,
      TotalCost: getRandomPrice(140),
      TotalForSale: getRandomPrice(140) + 25,
      TotalForTrade: getRandomPrice(140) + 25,
    },
    {
      GraphId: 15,
      UserId: 1,
      DateSaved: '2024-02-05',
      TotalValue: 155,
      TotalCost: getRandomPrice(155),
      TotalForSale: getRandomPrice(155) + 25,
      TotalForTrade: getRandomPrice(155) + 25,
    },
  ];
  
  // Calculate the cumulative sum for SpendPerDay
  const cumulativeSums = spendPerWeek.map((data, index) => {
    const sum = spendPerWeek.slice(0, index + 1).reduce((acc, current) => acc + current.TotalValue, 0);
    return { date: data.DateSaved, sum };
  });
  // Function to generate random paidPrice values
  // Define a function to generate random prices for testing
function getRandomPrice(max) {
  return Math.floor(Math.random() * max) + 1;
}

  
 // Just as an example
  

  

      
//   return (
//     <>
//     <div>PersonalCollection</div>
// <LiveCollectionCharts cardPrices={cardPrices}></LiveCollectionCharts>

// </>

  
  const collection1 = [1, 3, 5, 7, 9, 11, 13, 15];
  const collection2 = [2, 4, 6, 8, 10, 12, 14];
  const collection3 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  
  
  
  const collections = [
    {
      id: 1,
      name: "Collection 1",
      items: collection1,
    },
    {
      id: 2,
      name: "Collection 2",
      items: collection2,
    },
    {
      id: 3,
      name: "Collection 3",
      items: collection3,
    },
  ];



  
 
  return (
    <>
      <div> <h2>PersonalCollection</h2></div>
      <LiveCollectionCharts
        spendPerWeek={spendPerWeek}
        spendPerDay={spendPerDay}
        collections={collections}
      />
      <div style={{width:700}}>
      <BarChartForSaleForTrade 
      spendPerWeek={spendPerWeek}
      spendPerDay={spendPerDay}/>
      </div>
    </>
  );
};
//<LineChart data={lineChartData} width={800} ratio={1} />
export default PersonalCollection;